import axios from 'axios'
import React, { useEffect, useState } from 'react'
import { Controller, useForm } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import { Form, Icon, Segment } from 'semantic-ui-react'
import MilkMoneyAccountingService from '~/api/services/milkMoneyAccounting'
import FileUpload from '~/components/FileUpload'
import { FormFields } from '~/components/FormFields'
import Layout from '~/components/Layout'
import { El } from '~/components/Layout/style'
import notify from '~/components/Notify'
import { StyledDeleteButton, StyledFileLabel, StyledFileWrapper } from '~/pages/Dairy/MilkFixedPrice/style'
import { RouteTypes } from '~/routes/constants'
import ENV from '~/environment';
import { useNavigate } from 'react-router-dom'

const ImportTours: React.FC = () => {
  const { t } = useTranslation()
  const [isBusy, setIsBusy] = useState(false)
  const [options, setOptions] = useState(null)
  const navigate = useNavigate()

  const { handleSubmit, control, watch, setValue, reset } = useForm({
    mode: 'onSubmit'
  })

  const watchTypeField = watch('type')
  const watchFile = watch('file')
  const watchFileOne = watch('file1')
  const watchSecondFile = watch('file2')

  useEffect(() => {
    fetchData()
  }, [])

  useEffect(() => {
    reset({
      type: watchTypeField
    })
  }, [watchTypeField])

  async function fetchData() {
    setIsBusy(true)
    try {
      const response = await MilkMoneyAccountingService.importMoneyToursOptions()
      setOptions(response.data)
    } catch (error) {
      if (error.response.data) {
        notify(error.response.data.message, 'error')
      } else {
        notify(t('General error'), 'error')
      }
    }
    setIsBusy(false)
  }

  function renderBartecForm() {
    return <>
      <Segment loading={isBusy} style={{ position: 'relative', minWidth: 230, width: '50%' }}>
        {watchFileOne && renderFile(watchFileOne, 'file1')}
        <FormFields.External
          control={control}
          name={'file1'}
          rules={{
            required: {
              value: true,
              message: t('Please upload a prf file type')
            }
          }}
          label={t('Milk collection truck - milk samples')}
          onChange={(file) => setValue('file1', file)}
        >
          <FileUpload
            type='button'
            mimeTypes={['prf', 'PRF', 'ads', 'ADS']}
            sizeLimitInMB={10}
          />
        </FormFields.External>
      </Segment>
      <Segment key={1} loading={isBusy} style={{ position: 'relative', minWidth: 230, width: '50%' }}>
        {watchSecondFile && renderFile(watchSecondFile, 'file2')}
        <FormFields.External
          control={control}
          name={'file2'}
          label={t('Milk collection truck - quantities')}
          rules={{
            required: {
              value: true,
              message: t('Please upload a prf file type')
            }
          }}
          onChange={(file) => setValue('file2', file)}
        >
          <FileUpload
            type='button'
            mimeTypes={['prf', 'PRF', 'ads', 'ADS']}
            sizeLimitInMB={10}
          />
        </FormFields.External>
      </Segment>
    </>
  }

  function renderSchwarte() {
    return <Segment loading={isBusy} style={{ position: 'relative', minWidth: 230, width: '50%' }}>
      {watchFile && renderFile(watchFile, 'file')}
      <FormFields.External
        control={control}
        name={'file'}
        rules={{
          required: {
            value: true,
            message: t('Please upload a prf file type')
          }
        }}
        label={t('Milk collection truck (quantities & milk samples)')}
        onChange={(file) => {
          setValue('file', file)
        }}
      >
        <FileUpload
          mimeTypes={['prf', 'PRF', 'ads', 'ADS']}
          type='button'
          sizeLimitInMB={10}
        />
      </FormFields.External>
    </Segment>
  }

  function renderForm() {
    return <div style={{ margin: 20 }}>
      <Controller
        control={control}
        name={'type'}
        defaultValue=''
        rules={{
          required: {
            value: true,
            message: t('Please select type')
          }
        }}
        render={() => (
          <>
            {options?.types?.map((type, index) => (
              <Form.Checkbox
                key={type.key}
                label={type.label}
                value={type.key}
                checked={watchTypeField === type.key}
                onChange={(e, { value }) => setValue('type', value)}
                radio
              />
            ))}
          </>
        )}
      />
      {watchTypeField === 'bartec' ? renderBartecForm() : watchTypeField && renderSchwarte()}
    </div>
  }

  function renderActions() {
    return <El.PageHeaderActionButton>{t('Import')}</El.PageHeaderActionButton>
  }

  async function onSubmit(data) {
    setIsBusy(true)
    try {
      const formData = new FormData()
      formData.append('type', data.type)
      if (data.file) {
        formData.append('file', data.file)
      }
      if (data.file1) {
        formData.append('file1', data.file1)
      }
      if (data.file2) {
        formData.append('file2', data.file2)
      }
      const url = '/milk-money/tours/import'
      await axios.post(`${ENV.API_URL}${url}`, formData, {
        headers: { 'Authorization': localStorage.getItem('token') }
      });
      notify(t('Successfully imported milk money tour'), 'success')
      navigate(RouteTypes.MILK_MONEY_DELIVERY)
    } catch (error) {
      if (error.response.data) {
        notify(error.response.data.message, 'error')
      } else {
        notify(t('General error'), 'error')
      }
    }
    setIsBusy(false)
  }

  function renderFile(file, name) {
    return <StyledFileWrapper>
      <StyledFileLabel
        basic
        color='blue'
      >
        <Icon name='file' />
        <div className='fileName'>{file?.name}</div>
      </StyledFileLabel>

      <StyledDeleteButton
        onClick={() => setValue(name, null)}
        rightAlign={10}
        size={'small'}
        basic
        color='red'
        type={'button'}
        icon='trash' />
    </StyledFileWrapper>
  }

  return <Layout
    isBusy={isBusy}
    title={t('Milk delivery Import')}
    close={RouteTypes.MILK_MONEY_DELIVERY}
    actions={renderActions()}
    segmented
    onSubmit={handleSubmit(onSubmit)}
  >
    {options && renderForm()}
  </Layout>
}
export default ImportTours